var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 893.517,
    height: 514.788,
    viewBox: "0 0 893.517 514.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.295;}.b{fill:#e4a024;}.b,.c,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s{fill-rule:evenodd;}.c{fill:#f2b01c;}.d{fill:#f8ba16;}.e{fill:#f2a01f;}.f{fill:#f5a81c;}.g{fill:#f5ac1b;}.h{fill:#f4a61d;}.i{fill:#f5d010;}.j{fill:#e3a525;}.k{fill:#e8be1f;}.l{fill:#efb81c;}.m{fill:#e4af23;}.n{fill:#dfa926;}.o{fill:#f5eb01;}.p{fill:#f1c617;}.q{fill:#f3e007;}.r{fill:#fde900;}.s{fill:#f5c713;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-1169.274 -6548.745)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1564.361,7649.566l-111.7,73.542,111.7,73.538Z",
    transform: "translate(-171.716 -733.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1452.665,7768.929l111.7-73.542-111.7-73.531Z",
    transform: "translate(-171.716 -778.951)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1452.665,7713.514l111.7-73.533-111.7-73.556Z",
    transform: "translate(-171.716 -870.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1410.579,7649.566v147.087l111.676-73.545Z",
    transform: "translate(-241.306 -733.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1522.252,7621.852l-111.67,73.547,111.67,73.535Z",
    transform: "translate(-241.302 -778.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1522.252,7566.425l-111.67,73.556,111.67,73.524Z",
    transform: "translate(-241.302 -870.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1774.811,7621.852l-111.689,73.516,111.689,73.566Z",
    transform: "translate(176.284 -778.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1816.9,7594.135l-111.689,73.548,111.689,73.54Z",
    transform: "translate(245.882 -824.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1816.9,7649.566l-111.689,73.542,111.689,73.555Z",
    transform: "translate(245.882 -733.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1705.213,7621.852v147.083l111.7-73.528Z",
    transform: "translate(245.882 -778.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1705.213,7566.425V7713.5l111.7-73.524Z",
    transform: "translate(245.882 -870.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1578.942,7685.788l111.7-73.533-111.7-73.547Z",
    transform: "translate(37.088 -916.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1690.637,7511l-111.7,73.523,111.7,73.547Z",
    transform: "translate(37.088 -962.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1648.549,7538.707l-111.7,73.547,111.7,73.533Z",
    transform: "translate(-32.519 -916.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1536.848,7658.07l111.7-73.547L1536.848,7511Z",
    transform: "translate(-32.515 -962.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1621.039,7768.935l111.652-73.55-111.652-73.533Z",
    transform: "translate(106.697 -778.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1732.7,7594.134l-111.658,73.554,111.658,73.533Z",
    transform: "translate(106.697 -824.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1690.648,7621.852l-111.707,73.533,111.707,73.55Z",
    transform: "translate(37.088 -778.955)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1578.942,7741.208l111.707-73.517-111.707-73.547Z",
    transform: "translate(37.088 -824.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1648.536,7594.134l-111.683,73.554,111.683,73.533Z",
    transform: "translate(-32.507 -824.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1494.758,7741.208l111.694-73.517-111.694-73.547Z",
    transform: "translate(-102.113 -824.773)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg2);
export default __webpack_public_path__ + "static/media/login_bg2.9c2ed18573d1d970dbe12345d7dc94a9.svg";
export { ForwardRef as ReactComponent };